import { Box } from '@user-portal/wikr-components';
import styled from 'styled-components';

export const ScanQrCodeWrapper = styled(Box)<{
    $borderRadius: number;
    $paddingBottom: number;
    $paddingTop: number;
    $paddingX: number;
    $backgroundColor: string;
    $mb: number;
    $size: number;
}>`
    ${({ $mb }) => Number.isInteger($mb) && `margin-bottom: ${$mb}px;`};
    ${({ $paddingTop }) => Number.isInteger($paddingTop) && `padding-top: ${$paddingTop}px;`};
    ${({ $paddingBottom }) => Number.isInteger($paddingBottom) && `padding-bottom: ${$paddingBottom}px;`};
    ${({ $borderRadius }) => Number.isInteger($borderRadius) && `border-radius: ${$borderRadius}px;`};
    ${({ $paddingX }) => Number.isInteger($paddingX) && `padding-left: ${$paddingX}px; padding-right: ${$paddingX}px;`};
    ${({ theme, $backgroundColor }) => $backgroundColor && `background-color: ${theme[$backgroundColor]};`};
    width: ${({ $size }) => (Number.isInteger($size) ? `${$size + 40}px` : '220px')};
    height: ${({ $size }) => (Number.isInteger($size) ? `${$size + 40}px` : '220px')};
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
`;
